export default __webpack_public_path__ + "static/media/favicon.7ad48a02.svg";